<template>
  <v-card class="pb-5 rounded-xl rounded-b-0" flat>
    <v-img
      class="elevation-2"
      :height="$vuetify.breakpoint.smAndUp ? '200px' : '100px'"
      src="@/assets/bcg4.jpg"
      gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"
    ></v-img>
    <v-row :class="$vuetify.breakpoint.smAndUp ? 'ml-6 mt-n8' : 'ml-2 mt-n6'">
      <v-list-item>
        <v-list-item-avatar :size="size" class="elevation-2">
          <img src="@/assets/photo.jpg" alt="Oussama Bouhenniche" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title text-wrap" style="margin-top:20px;"
            >Oussama BOUHENNICHE</v-list-item-title
          >
          <v-list-item-subtitle>{{ $t("home.jobTitle") }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-row>
    <div>
      <p
        :class="$vuetify.breakpoint.xs ? 'text-caption my-6 mx-2' : 'my-6 mx-9'"
      >
        {{ $t("home.descreption[0]") }}
        <br />
        {{ $t("home.descreption[1]") }}
      </p>
      <div>
        <title-box :title="'Compétences'"></title-box>
        <v-row class="mx-2"
          ><v-col v-for="item in items" :key="item.title"
            ><v-chip>
              {{ item.title }}
            </v-chip></v-col
          ></v-row
        >
      </div>
    </div>
  </v-card>
</template>

<script>
import TitleBox from "./comon/TitleBox.vue";
export default {
  name: "Home",

  components: { TitleBox },

  data() {
    return {
      items: [
        {
          title: "Vue.js",
          value: 20,
          color: "red"
        },
        {
          title: "Vuetify",
          value: 50,
          color: "purple"
        },
        {
          title: "HTML",
          value: 90,
          color: "green"
        },
        {
          title: "CSS",
          value: 100,
          color: "yellow"
        },
        {
          title: "Javascript",
          value: 100,
          color: "yellow"
        },
        {
          title: "Bootstrap",
          value: 100,
          color: "yellow"
        },
        {
          title: "Node.js",
          value: 100,
          color: "yellow"
        },
        {
          title: "Python",
          value: 100,
          color: "yellow"
        },
        {
          title: "C++",
          value: 100,
          color: "yellow"
        }
      ]
    };
  },

  computed: {
    size() {
      let size = 60;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          size = 80;
          break;
        case "sm":
          size = 80;
          break;
        case "md":
          size = 100;
          break;
        case "lg":
          size = 100;
          break;
        case "xl":
          size = 100;
          break;
      }
      return size;
    }
  }
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
